// Polyfill for requestIdleCallback and cancelIdleCallback
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

// 移除WDYR导入
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.js';
import '@readsavor/ui/styles'; // 导入 UI 包的样式
import './index.css';
import { initializeStorageServices, registerContentProcessors } from '@readsavor/core';
import { initializePdfWorker } from './config/pdfWorker.js';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Function to render the application
const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
};

// Asynchronous IIFE to initialize services and then render the app
(async () => {
  try {
    // 🔄 移除 createSupabaseBrowserClient() 调用
    // Auth系统现在使用API客户端架构，会自动初始化
    // Supabase客户端现在通过独立服务层按需创建

    initializePdfWorker(); // 初始化PDF worker
    // Initialize core services before rendering the application
    await initializeStorageServices(); // Wait for storage services to be ready
    registerContentProcessors(); // 注册内容处理器

    // Render the app only after successful initialization
    renderApp();
  } catch (error) {
    // Handle initialization error appropriately, maybe show an error message to the user
    // Optionally, render a specific error component instead of the main app
    // ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<InitializationErrorComponent />);
  }
})();
